import React from 'react'

import FieldItem from "./option-item/field-item"

export default function CustomFields(props:any) {

    const group = _.find(props.manageColumnsConfig, group=>group.groupId === props.section);

    return (
        <>
            {_.map(group.fields, fieldId=>{
                const field = _.find(props.fields, field=>field.fieldId === fieldId);
                const selectedColumn = _.find(props.columns, column=>column.fieldId === fieldId);

                return <FieldItem key                   = {fieldId}
                                  field                 = {field}
                                  params                = {selectedColumn?.params}
                                  selected              = {!!selectedColumn}
                                  hasIcons              = {true}
                                  showModifierOptions   = {props.showModifierOptions}
                                  onClick               = {props.onToggleColumn}/>
            })}

            {props.showAdd &&
            <div className="option" onClick={()=>{props.onSelectSection('new-field')}}>
                <div className="label add">
                    New custom field
                </div>
            </div>}
        </>
    );
}